import React from 'react';

const NewFile = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox='0 0 40 40'>
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m23.656 3.523 8.288 8.531.244.975v4.875H29.75v-2.437H20v-9.75H7.812v26.812h9.75v2.438H6.595l-1.219-1.219V4.498l1.219-1.219h16.331l.731.244Z
        m-1.218 2.194v7.312h7.068l-7.069-7.312Z
        m9.75 34.125H29.75v-7.313h-7.313v-2.437h7.313v-7.313h2.438v7.313H39.5v2.437h-7.313v7.313Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5.842h39v39H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default NewFile;
